/** Offline / pre-login identity; all legacy rows are attributed to this user until sync. */
export const LOCAL_DEFAULT_USER_ID = '00000000-0000-0000-0000-000000000001';
